"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledItem = exports.StyledFlex = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Responsive_1 = require("../../shared/Responsive");
const StyledFlex = styled_components_1.default.div `
    display: ${({ $display }) => $display};

    ${({ $alignItems }) => $alignItems && (0, Responsive_1.responsiveCssToMedia)($alignItems, "align-items")}

    ${({ $flexDirection }) => $flexDirection &&
    (0, Responsive_1.responsiveCssToMedia)($flexDirection, "flex-direction")}

    ${({ $flexWrap }) => $flexWrap && (0, Responsive_1.responsiveCssToMedia)($flexWrap, "flex-wrap")}

    ${({ $gap }) => $gap && (0, Responsive_1.responsiveCssToMedia)($gap, "gap")}

    ${({ $justifyContent }) => $justifyContent &&
    (0, Responsive_1.responsiveCssToMedia)($justifyContent, "justify-content")}

    ${({ $p }) => {
    return $p && (0, Responsive_1.responsiveCssToMedia)($p, "padding");
}}
    
    ${({ $px }) => {
    return $px && (0, Responsive_1.responsiveCssToMedia)($px, "padding-right");
}}

    ${({ $px }) => {
    return $px && (0, Responsive_1.responsiveCssToMedia)($px, "padding-left");
}}

    ${({ $py }) => {
    return $py && (0, Responsive_1.responsiveCssToMedia)($py, "padding-top");
}}

    ${({ $py }) => {
    return $py && (0, Responsive_1.responsiveCssToMedia)($py, "padding-bottom");
}}
    
    ${({ $pt }) => {
    return $pt && (0, Responsive_1.responsiveCssToMedia)($pt, "padding-top");
}}
    
    ${({ $pr }) => {
    return $pr && (0, Responsive_1.responsiveCssToMedia)($pr, "padding-right");
}}
    
    ${({ $pb }) => {
    return $pb && (0, Responsive_1.responsiveCssToMedia)($pb, "padding-bottom");
}}
    
    ${({ $pl }) => {
    return $pl && (0, Responsive_1.responsiveCssToMedia)($pl, "padding-left");
}}
`;
exports.StyledFlex = StyledFlex;
const StyledItem = styled_components_1.default.div `
    ${({ $flex }) => $flex && (0, Responsive_1.responsiveCssToMedia)($flex, "flex")}
`;
exports.StyledItem = StyledItem;
//# sourceMappingURL=Flex.styles.js.map